import React from "react"
import { useAppDispatch, useAppSelector } from "../../../../../app/hooks"
import { Switch, SwitchChangeEvent } from "@progress/kendo-react-inputs";
import { useSavePreQuoteCompleteMutation } from "../../../../../services/verifyService/verify-api";
import { PreQuoteCompleteCommand } from "../../../../../services/verifyService/commands";
import { editAttributes } from "../../../../../services/verifyService/model/verification/VerificationSlice";
import { ReduxUpdate } from "../../../../../utils/ReduxUpdateCommands";
import { PreQuoteEditDialog } from "./PreQuoteEditDialog";

function PreQuoteCompleteAttribute(){
    const dispatch = useAppDispatch();
    const verify = useAppSelector((state)=>state.verification.verification);
    const [savePreQuoteComplete] = useSavePreQuoteCompleteMutation();

    const isPreQuote = verify.verifyAttributes.isPreQuote ?? false;

    if(!isPreQuote) return null;

    const handleChange = async (e: SwitchChangeEvent) => {
        const newValue = e.target.value;
        const previousValue = verify.verifyAttributes.preQuoteComplete ?? false;
        dispatch(editAttributes(new ReduxUpdate("preQuoteComplete", newValue)));
        try {
            await savePreQuoteComplete(new PreQuoteCompleteCommand(verify.id!, newValue)).unwrap();
        } catch {
            dispatch(editAttributes(new ReduxUpdate("preQuoteComplete", previousValue)));
        }
    }

    return <React.Fragment>
        <div>
            <label>Pre Quote Completed</label><br/>
            <Switch name='preQuoteComplete' value={verify.verifyAttributes.preQuoteComplete ?? false}
                checked={verify.verifyAttributes.preQuoteComplete}
                onChange={handleChange}/>
        </div>
        <PreQuoteEditDialog />
    </React.Fragment>
}
export {PreQuoteCompleteAttribute}
